import React from 'react';

/**
 * StatCard — overline label, big tabular metric value, optional sub-caption.
 * `tone="danger" | "success"` colors the value when it signals a problem/good
 * state (e.g. a discrepancy figure). Use <StatGrid> to lay out a row of four.
 */
export function StatCard({ label, value, sub, tone, valueClassName = '', children }) {
  const valueTone = tone ? ` ui-statcard__value--${tone}` : '';
  return (
    <div className="ui-statcard">
      <div className="ui-statcard__label">{label}</div>
      <div className={`ui-statcard__value${valueTone} ${valueClassName}`.trim()}>{value}</div>
      {sub && <div className="ui-statcard__sub">{sub}</div>}
      {children}
    </div>
  );
}

export function StatGrid({ className = '', children }) {
  return <div className={`ui-statgrid ${className}`.trim()}>{children}</div>;
}

export default StatCard;
